import { Box, Typography } from '@mui/material'

const NoNovedades = () => {
  return (
    <Box
      bgcolor="white"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      minHeight="400px"
      borderRadius="8px"
      width="100%"
    >
      <Typography fontSize={24} fontWeight="bold" align="center">
        No hay novedades disponibles
      </Typography>
    </Box>
  )
}

export default NoNovedades
